import {
  Layout,
  Shield,
  ClipboardCheck,
  BarChart3,
  Wrench,
  BookOpen,
} from 'lucide-react';
import type { CreateAgentSkillInput } from '../../../../api/agent-skills';

export const WORKSPACE_OPTIONS = [
  'plerion-platform',
  'slack',
  'email',
  'extension',
] as const;

export const EMPTY_FORM: CreateAgentSkillInput = {
  name: '',
  displayName: '',
  description: '',
  workspace: [],
  instructions: '',
  scope: 'user',
  enabled: true,
};

export function formatBytes(bytes: number): string {
  if (bytes === 0) {
    return '0 B';
  }
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / Math.pow(k, i)) * 10) / 10} ${sizes[i]}`;
}

export const TEMPLATE_CATEGORY_META = {
  security: {
    icon: Shield,
    color: 'text-red-500',
    bg: 'bg-red-50 dark:bg-red-950/40',
  },
  compliance: {
    icon: ClipboardCheck,
    color: 'text-green-500',
    bg: 'bg-green-50 dark:bg-green-950/40',
  },
  reporting: {
    icon: BarChart3,
    color: 'text-blue-500',
    bg: 'bg-blue-50 dark:bg-blue-950/40',
  },
  devops: {
    icon: Wrench,
    color: 'text-purple-500',
    bg: 'bg-purple-50 dark:bg-purple-950/40',
  },
  general: {
    icon: BookOpen,
    color: 'text-gray-500',
    bg: 'bg-gray-50 dark:bg-gray-700',
  },
} as const;
